import styled from 'styled-components'
import { Tag } from 'antd'

export const ModalContent = styled.div`
  display: flex;
  gap: 16px;
  min-height: 500px;
`

export const ItemList = styled.div<{ $isTarget?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${props => (props.$isTarget ? '#fafafa' : '#fff')};
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
`

export const ListHeader = styled.div`
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #d9d9d9;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeaderTitle = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
`

export const HeaderCounter = styled(Tag)`
  margin: 0;
  font-size: 12px;
`

export const ListBody = styled.div`
  flex: 1;
  padding: 8px;
  overflow-y: auto;
  max-height: 450px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const ItemCard = styled.div<{ $isDragging?: boolean; $isAvailable?: boolean }>`
  padding: 8px 10px;
  margin-bottom: 6px;
  background: white;
  border: 1px solid ${props => (props.$isDragging ? '#1890ff' : '#d9d9d9')};
  border-radius: 6px;
  cursor: ${props => (props.$isAvailable ? 'pointer' : 'grab')};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: ${props => (props.$isDragging ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none')};
  animation: slideIn 0.2s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  &:active {
    cursor: ${props => (props.$isAvailable ? 'pointer' : 'grabbing')};
    transform: translateY(0);
  }
`

export const DragHandle = styled.div`
  color: #8c8c8c;
  display: flex;
  align-items: center;
  font-size: 14px;
`

export const ItemContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const ItemTitle = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemDescription = styled.div`
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`

export const SortOrderBadge = styled(Tag)`
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  min-width: 22px;
  padding: 0 4px;
  text-align: center;
  line-height: 18px;
`

export const SearchWrapper = styled.div`
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
`

